import React from 'react';
const ArrowIcon = ({ active, direction, styles={} }) => {
  return (
    <svg
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 512 512"
      style={{width: '33px', height: '33px', ...styles}}
    >
      <g>
        <g>
          <path
            fill={active ? '#888' : 'rgba(136, 136, 136, 0.35)'}
            style={direction === 'left' ? {
              transform: 'rotate(180deg)',
              transformOrigin: 'center'
            }: {}}
            d="M506.134,241.843c-0.006-0.006-0.011-0.013-0.018-0.019l-104.504-104c-7.829-7.791-20.492-7.762-28.285,0.068
          c-7.792,7.829-7.762,20.492,0.067,28.284L443.558,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h423.557
          l-70.162,69.824c-7.829,7.792-7.859,20.455-0.067,28.284c7.793,7.831,20.457,7.858,28.285,0.068l104.504-104
          c0.006-0.006,0.011-0.013,0.018-0.019C513.968,262.339,513.943,249.635,506.134,241.843z"
          />
        </g>
      </g>
    </svg>
  );
};
const DropdownArrowIcon = ({
  styles = {},
}) => {
  return (
    <svg
      version="1.1"
      id="Capa_2"
      x="0px"
      y="0px"
      viewBox="0 0 213.333 213.333"
      style={{ width: "10px", height: "10px", display: 'inline-block', ...styles }}
    >
      <g>
        <g>
          <polygon points="0,53.333 106.667,160 213.333,53.333 		" />
        </g>
      </g>
    </svg>
  );
};
const CheckedIcon = ({ styles = {width: 20, height: 20} }) => {
  return (
    <svg viewBox="0 0 512 512" style={{...styles}}><path d="m256 0c-141.164062 0-256 114.835938-256 256s114.835938 256 256 256 256-114.835938 256-256-114.835938-256-256-256zm0 0" fill="#2196f3"/><path d="m385.75 201.75-138.667969 138.664062c-4.160156 4.160157-9.621093 6.253907-15.082031 6.253907s-10.921875-2.09375-15.082031-6.253907l-69.332031-69.332031c-8.34375-8.339843-8.34375-21.824219 0-30.164062 8.339843-8.34375 21.820312-8.34375 30.164062 0l54.25 54.25 123.585938-123.582031c8.339843-8.34375 21.820312-8.34375 30.164062 0 8.339844 8.339843 8.339844 21.820312 0 30.164062zm0 0" fill="#fafafa"/></svg>
  )
}
export { ArrowIcon, DropdownArrowIcon, CheckedIcon };

